import React from "react";
import { useFieldArray } from "react-hook-form";
import Button from "../../../Common/Button/Button";
import Input from "../../../Common/Input/Input";
import PlusIcon from "../../../Common/SvgIcons/CommonIcons/PlusIcon";
// import CrossIcon from "../../../Common/SvgIcons/SocialIcons/CrossIcon";
import DeleteIcon from "../../../Common/SvgIcons/TableIcons/DeleteIcon";
import Tooltip from "../../../Common/ToolTip/Tooltip";
import { useSelector } from "react-redux";
import classes from "./AddSurveyAnswerArr.module.scss";
import { FormattedMessage } from "react-intl";
const AddSurveyAnswerArr = ({
  activeTab,
  activeQuestionIndex,
  errors,
  control,
  shotclassType,
  trigger,
  isDistributed,
  isValid,
  surveyType,
  isScored,
}) => {
  const commonState = useSelector((state) => state.commonReducer);
  const { colors } = commonState;
  const {
    fields: answersFields,
    append: appendAnswer,
    remove: removeAnswer,
  } = useFieldArray({
    control,
    name: `QuestionsList.${activeQuestionIndex}.AnswersList`,
  });

  const onKeyDown = (e) => {
    debugger;
    // Prevent arrow keys, decimal point, minus sign, and 'e'
    if (
      e.key === "ArrowUp" ||
      e.key === "ArrowDown" ||
      e.key === "." ||
      e.key === "-" ||
      e.key === "e" ||
      e.key === "E"
    ) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  const onWheel = (e) => {
    debugger;
    // Prevent mouse wheel from changing the number input value
    e.preventDefault();
    e.stopPropagation();
  };

  const onMouseEnter = (e) => {
    // Add wheel event listener when mouse enters
    e.currentTarget.addEventListener("wheel", preventWheel, { passive: false });
  };

  const onMouseLeave = (e) => {
    // Remove wheel event listener when mouse leaves
    e.currentTarget.removeEventListener("wheel", preventWheel);
  };

  const preventWheel = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.currentTarget.blur();
    return false;
  };

  return activeTab === 1 ? (
    <div className={classes.addSurveyAnswerArr__answersFields}>
      {answersFields.map((item, index, ansArr) => {
        return (
          <div
            key={item.id}
            className={classes.addSurveyAnswerArr__answersFields__answerField}
          >
            <div
              className={
                classes.addSurveyAnswerArr__answersFields__answerField__answerInput
              }
            >
              <Input
                name={`QuestionsList.${activeQuestionIndex}.AnswersList.${index}.Answer`}
                label={`Answer ${index + 1}`}
                labelMsg="(Max : 250 Characters)"
                placeholder="Write Choice Text Here"
                labelColor="light"
                error={
                  errors?.QuestionsList?.[activeQuestionIndex]?.AnswersList?.[
                    index
                  ]?.Answer?.message
                }
                errorPosition="absolute"
                type="textarea"
                maxLength={250}
                disabled={shotclassType === "view"}
                onChange={() => {
                  trigger([`QuestionsList.${activeQuestionIndex}.AnswersList`]);
                }}
              />
            </div>
            {isScored && (
              <div
                className={
                  classes.addSurveyAnswerArr__answersFields__answerField__scoreField
                }
              >
                <Input
                  name={`QuestionsList.${activeQuestionIndex}.AnswersList.${index}.Score`}
                  label="Points"
                  placeholder="0"
                  labelColor="light"
                  type="number"
                  min={0}
                  max={999}
                  disabled={
                    shotclassType === "view" ||
                    ((shotclassType === "edit" || shotclassType === "copy") &&
                      isDistributed)
                  }
                  width={7}
                  error={
                    errors?.QuestionsList?.[activeQuestionIndex]?.AnswersList?.[
                      index
                    ]?.Score?.message
                  }
                  onChange={() => {
                    trigger([
                      `QuestionsList.${activeQuestionIndex}.AnswersList`,
                    ]);
                  }}
                  onKeyDown={onKeyDown}
                  onWheel={onWheel}
                  onMouseEnter={onMouseEnter}
                  onMouseLeave={onMouseLeave}
                />
              </div>
            )}
            {index !== 0 && !isDistributed && (
              <Tooltip content="Delete" direction="bottom">
                <span
                  onClick={() => {
                    if (shotclassType !== "view") {
                      removeAnswer(index);
                    }
                  }}
                  className={
                    classes.addSurveyAnswerArr__answersFields__answerField__removeIcon
                  }
                >
                  <DeleteIcon fill={colors.theme} />
                </span>
              </Tooltip>
            )}
            {index === ansArr.length - 1 &&
              !errors?.QuestionsList?.[activeQuestionIndex]?.AnswersList?.[
                index
              ]?.Answer?.message && (
                <div
                  className={
                    classes.addSurveyAnswerArr__answersFields__answerField__error
                  }
                >
                  {
                    errors?.QuestionsList?.[activeQuestionIndex]?.AnswersList
                      ?.message
                  }
                </div>
              )}
          </div>
        );
      })}
      <div className={classes.addSurveyAnswerArr__addMultiContainer}>
        <Button
          label="Add New"
          height="3"
          width="11.3"
          icon={PlusIcon}
          onClick={() => {
            if (
              (answersFields?.length < 5 && surveyType === "basic") ||
              (answersFields?.length < 10 && surveyType === "scored")
            ) {
              const newAnswer = isScored
                ? { Answer: "", Score: 0 }
                : { Answer: "" };
              appendAnswer(newAnswer);
            }
          }}
          light
          type="button"
          disabled={
            shotclassType === "view" ||
            (answersFields?.length >= 5 && surveyType === "basic") ||
            (answersFields?.length >= 10 && surveyType === "scored") ||
            isDistributed
          }
        />
        {!isScored && (
          <Input
            label={<FormattedMessage id="MultiSelect" />}
            name={`QuestionsList.${activeQuestionIndex}.MultiSelect`}
            type="checkbox"
            labelColor={colors.theme}
            direction="row-reverse"
            width="2"
            height="2"
            disabled={shotclassType === "view"}
          />
        )}
      </div>
    </div>
  ) : activeTab === 2 ? (
    <>
      <div className={classes.addSurveyAnswerArr__trueOrFalse}>
        <div className={classes.addSurveyAnswerArr__trueOrFalse__fields}>
          <div className={classes.addSurveyAnswerArr__trueOrFalse__field}>
            <Input
              label="1. True"
              name="IsCorrect"
              type="radio"
              width="2"
              height="2"
              value={true}
              direction="row-reverse"
              disabled
              hidden
            />
            {isScored && (
              <div
                className={
                  classes.addSurveyAnswerArr__trueOrFalse__field__scoreField
                }
              >
                <Input
                  label="Points"
                  name={`QuestionsList.${activeQuestionIndex}.AnswersList.0.Score`}
                  type="number"
                  placeholder="0"
                  min="0"
                  max="999"
                  disabled={shotclassType === "view"}
                  onKeyDown={onKeyDown}
                  onWheel={onWheel}
                  onMouseEnter={onMouseEnter}
                  onMouseLeave={onMouseLeave}
                />
              </div>
            )}
          </div>
          <div className={classes.addSurveyAnswerArr__trueOrFalse__field}>
            <Input
              label="2. False"
              name="IsCorrect"
              type="radio"
              width="2"
              height="2"
              value={false}
              direction="row-reverse"
              disabled
              hidden
            />
            {isScored && (
              <div
                className={
                  classes.addSurveyAnswerArr__trueOrFalse__field__scoreField
                }
              >
                <Input
                  label="Points"
                  name={`QuestionsList.${activeQuestionIndex}.AnswersList.1.Score`}
                  type="number"
                  placeholder="0"
                  min="0"
                  max="999"
                  disabled={shotclassType === "view"}
                  onKeyDown={onKeyDown}
                  onWheel={onWheel}
                  onMouseEnter={onMouseEnter}
                  onMouseLeave={onMouseLeave}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  ) : (
    <></>
  );
};

export default AddSurveyAnswerArr;
